import {connect} from 'react-redux'
import {
  setRefundItems,
  issueRefundRequest,
  askSetQuantity,
  confirmSetQuantity,
  cancelSetQuantity,
  cancelRefundBreakdown,
  setRefundItemsPromo
} from 'actions/reports/transactions'
import {Modal} from 'react-bootstrap'
import styles from './TransactionRefundModal.css'
import moment from 'moment'
import Gratuity from 'components/receipt/refunds/RefundBreakdownModal/Gratuity'
import Tax from 'components/receipt/refunds/RefundBreakdownModal/Tax'
import Discount from 'components/receipt/refunds/RefundBreakdownModal/Discount'
import RewardRedemption from 'components/receipt/refunds/RefundBreakdownModal/RewardRedemption'
import AmountToRefund from 'components/receipt/refunds/AmountToRefund'
import RefundReason from 'components/receipt/refunds/RefundReason'
import Item from 'components/receipt/refunds/RefundBreakdownModal/Item'
import ModalHeader from 'components/Modal/ModalHeader'
import * as mpReportsTransactions from 'mixpanel/reports/transactions'
import {formValueSelector} from 'redux-form'

class TransactionRefundModal extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      reasonForRefund: '',
      otherReasonForRefund: ''
    }
  }

  render () {
    let {openRefundBreakdownModal, refundBreakdown, transactionDetail, openSetQuantityModal} = this.props.data.reports.transactions
    // We must sort it first before get to the rendering
    let items = this._sortCheckouts(refundBreakdown.refundItems)
    return ((transactionDetail !== null) && <Modal onHide={this._onHide} show={openRefundBreakdownModal} bsClass='full-height-modal margin-top-modal modal'>
      <ModalHeader title='Issue Refund' />
      <Modal.Body bsClass={`${styles['modal-body']} modal-body`}>
        <AmountToRefund calculateAmountToRefund={this._calculateAmountToRefund} />
        <Item
          isChecked={this._isChecked}
          isSelectedAll={this._isSelectedAll}
          isRefunded={this._isRefunded}
          canBeRefunded={this._canBeRefunded}
          canSelectAll={() => true}
          onClickCheck={this._onClickCheck}
          onClickSelectAll={this._onClickSelectAll}
          onClickDeselectAll={this._onClickDeselectAll}
          onClickIncreaseQty={this._onClickIncreaseQty}
          onClickDecreaseQty={this._onClickDecreaseQty}
          onChangeInputAmountRefunded={this._onChangeInputAmountRefunded}
          refundItems={items}
          calculateItemPrice={!transactionDetail.include_gratuity_tax ? this._calculateItemPrice : this._calculateItemPriceIncluded}
          onAskSetQtyModal={this._onAskSetQtyModal}
          onConfirmSetQtyModal={this._onConfirmSetQtyModal}
          onCancelSetQtyModal={this._onCancelSetQtyModal}
          openSetQtyModal={openSetQuantityModal}
          showCheckbox
          isSalesType={transactionDetail.is_sales_type}
          isPromoItem={this._isPromoItem}
          calculatePromoItemPrice={this._calculatePromoItemPrice}
          onClickCheckPromo={this._onClickCheckPromo}
          onClickIncreaseQtyPromo={this._onClickIncreaseQtyPromo}
          onClickDecreaseQtyPromo={this._onClickDecreaseQtyPromo}
          isFreeItem={this._isFreeItem}
          getPromoName={this._getPromoName}
        />
        <Discount
          paymentDiscounts={transactionDetail.payment_discounts}
          calculateDiscount={this._calculateDiscount}
          />
        <RewardRedemption
          redeemReward={this._getRewardName()}
          redeemAmount={this._calculateRedeemAmount()}
         />
        <Gratuity
          includeGratuityTax={transactionDetail.include_gratuity_tax}
          paymentGratuities={transactionDetail.payment_gratuities}
          calculateGratuity={this._calculateGratuity}
          />
        <Tax
          includeGratuityTax={transactionDetail.include_gratuity_tax}
          paymentTaxes={transactionDetail.payment_taxes}
          calculateTax={this._calculateTax}
          />
        <RefundReason
          labelReason='Reason for Refund'
          onChangeOtherReasonForRefund={this._onChangeOtherReasonForRefund}
          onChangeReasonForRefund={this._onChangeReasonForRefund}
          />
      </Modal.Body>
      <Modal.Footer>
        <div className='pull-left'>
          <button type='button' className='btn btn-default' onClick={this._onHide}>Cancel</button>
        </div>
        <div>
          <button
            type='button'
            className='btn btn-primary pull-right'
            onClick={this._onClickIssueRefund}
            disabled={!this._isIssueRefundButtonEnabled() || this._calculateAmountToRefund() === 0}
          >
              Issue Refund
          </button>
        </div>
      </Modal.Footer>
      </Modal>)
  }
  _sortCheckouts = (checkouts) => {
    const sortedSt = {}
    const sortedNoSt = {}
    let key
    let a = []
    for (key in checkouts) {
      if (checkouts.hasOwnProperty(key)) {
        a.push(key)
      }
    }
    a.sort(this._insensitive)
    for (key = 0; key < a.length; key++) {
      if (a[key] !== 'No Sales Type') {
        sortedSt[a[key]] = checkouts[a[key]]
      } else {
        sortedNoSt[a[key]] = checkouts[a[key]]
      }
    }
    return Object.assign(sortedSt, sortedNoSt)
  }

  _insensitive = (s1, s2) => {
    var s1lower = s1.toLowerCase()
    var s2lower = s2.toLowerCase()
    return s1lower > s2lower ? 1 : (s1lower < s2lower ? -1 : 0)
  }

  _getRewardName = () => {
    const {transactionDetail} = this.props.data.reports.transactions
    return transactionDetail.loyalty && transactionDetail.loyalty.type.toLowerCase() === 'redemption' ? transactionDetail.loyalty.redemption.reward : ''
  }

  _onHide = () => {
    const {transactionDetail} = this.props.data.reports.transactions
    this.setState({reasonForRefund: null})
    this.props.dispatch(cancelRefundBreakdown(transactionDetail))
  }

  _onChangeReasonForRefund = (value) => {
    this.setState({reasonForRefund: value})
  }

  _onChangeOtherReasonForRefund = (value) => {
    this.setState({otherReasonForRefund: value})
  }

  _isIssueRefundButtonEnabled = () => {
    // if all items are refunded disable it
    let hasItemRefunded = false
    let {refundItems} = this.props.data.reports.transactions.refundBreakdown
    for (var salesType in refundItems) {
      refundItems[salesType].forEach((refundItem) => {
        if (refundItem.pricePerItem > 0) {  // item with 0 price can't be refunded, except from promo
          hasItemRefunded = (hasItemRefunded || refundItem.isRefunded)
        }
      })
    }

    if (this.state.reasonForRefund === 'Other') {
      //! ! --> boolean not empty
      return (hasItemRefunded && !!this.state.otherReasonForRefund)
    } else {
      //! ! --> boolean not empty
      return (hasItemRefunded && !!this.state.reasonForRefund)
    }
  }

  _onClickIssueRefund = () => {
    let {refundItems, refundItemsPromo} = this.props.data.reports.transactions.refundBreakdown
    let {transactionDetail} = this.props.data.reports.transactions

    // disable button issue refund to prevent multiple click by user
    this._isIssueRefundButtonEnabled = () => { return false }

    // construct items
    let itemCallbacks = []

    let itemsPromo = []
    refundItemsPromo && refundItemsPromo.forEach((promo) => {
      itemsPromo.push(promo)
    })

    for (var salesType in refundItems) {
      refundItems[salesType].forEach((refundItem) => {
        // items - discounts
        let itemDiscounts = refundItem.discounts.map((discount) => {
          return {
            discount_id: discount.discount_id,
            discount_name: discount.discount_name,
            discount_type: discount.discount_type,
            discount_cash: discount.discount_cash,
            discount_percentage: discount.discount_percentage,
            discount_amount: -refundItem.refundAmount * discount.discount_per_item
          }
        })
        // items - modifiers
        let itemModifiers = refundItem.modifiers.map((modifier) => {
          modifier.gross_sales = -refundItem.refundAmount * modifier.gross_per_item
          modifier.net_sales = -refundItem.refundAmount * modifier.net_per_item
          modifier.discount_amount = -refundItem.refundAmount * modifier.discount_per_item
          modifier.redeem_amount = -refundItem.refundAmount * modifier.redeem_per_item
          modifier.modifier_discounts = modifier.modifier_discounts.map((modifierDiscount) => {
            modifierDiscount.discount_amount = -refundItem.refundAmount * modifierDiscount.discount_per_item
            return modifierDiscount
          })
          return modifier
        })
        let itemGratuities = []
        if (refundItem.salesTypeId && refundItem.salesTypeId !== 0) {
          itemGratuities = refundItem.gratuities.map((gratuity) => {
            const dataGratuity = {
              gratuity_percentage: gratuity.amount,
              gratuity_amount: -(((gratuity.amount / 100) * refundItem.netPerItem) * refundItem.refundAmount),
              gratuity_id: gratuity.gratuity_id,
              sales_type_id: gratuity.sales_type_id,
              gratuity_name: gratuity.gratuity_name
            }
            return dataGratuity
          })
        } else {
          itemGratuities = transactionDetail.payment_gratuities.map((gratuity) => {
            const dataGratuity = {
              gratuity_percentage: gratuity.amount,
              gratuity_amount: -(((gratuity.amount / 100) * refundItem.netPerItem) * refundItem.refundAmount),
              gratuity_id: gratuity.gratuity_id,
              sales_type_id: 0,
              gratuity_name: gratuity.name
            }
            return dataGratuity
          })
        }

        let isPromoItem = this._isPromoItem(refundItem.parentCheckoutId)
        let promoItemPrice = this._calculatePromoItemPrice(refundItem)
        let isFreeItem = this._isFreeItem(refundItem.parentCheckoutId)

        if (refundItem.isRefunded) {
          if (!isPromoItem || !(isPromoItem && promoItemPrice === 0 && !isFreeItem)) {
            itemCallbacks.push({
              category_id: refundItem.categoryId,
              category_name: refundItem.categoryName,
              client_price: refundItem.pricePerItem,
              discount_amount: -refundItem.refundAmount * refundItem.discountPerItem,
              redeem_amount: -refundItem.refundAmount * refundItem.redemptionPerItem,
              discounts: itemDiscounts,
              gratuity: -refundItem.refundAmount * refundItem.gratuityPerItem,
              gratuities: itemGratuities,
              gross_sales: -refundItem.refundAmount * refundItem.grossPerItem,
              item_id: refundItem.itemId,
              item_image: refundItem.itemImage,
              item_name: refundItem.itemName,
              item_variant_id: refundItem.itemVariantId,
              item_variant_name: refundItem.itemVariantName,
              item_variant_sku: refundItem.itemVariantSku,
              modifiers: itemModifiers,
              net_sales: -refundItem.refundAmount * refundItem.netPerItem,
              parent_checkout_id: refundItem.parentCheckoutId,
              position: refundItem.position,
              quantity: -refundItem.refundAmount,
              tax: -refundItem.refundAmount * refundItem.taxPerItem,
              track_stock: refundItem.trackStock,
              sales_type_id: refundItem.salesTypeId,
              sales_type_name: refundItem.salesTypeName,
              from_promo: this._isPromoItem(refundItem.parentCheckoutId)
            })
          }
        }
      })
    }

    // construct discounts
    let discounts = []
    transactionDetail.payment_discounts.forEach((discount) => {
      discounts.push({
        discount_amount: -this._calculateDiscount(discount.discount_id, discount.discount_amount),
        discount_cash: discount.discount_cash,
        discount_id: discount.discount_id,
        discount_name: discount.discount_name,
        discount_type: discount.discount_type
      })
    })

    // construct gratuities
    let gratuities = []
    transactionDetail.payment_gratuities.forEach((gratuity) => {
      var total = this._calculateGratuity(gratuity.gratuity_id)
      if (total !== 0) {
        gratuities.push({
          gratuity_amount: -total,
          gratuity_id: gratuity.gratuity_id,
          gratuity_name: gratuity.name,
          gratuity_percentage: gratuity.amount
        })
      }
    })

    // construct taxes
    let taxes = []
    transactionDetail.payment_taxes.forEach((tax) => {
      taxes.push({
        tax_amount: -this._calculateTax(tax.id),
        tax_id: tax.tax_id,
        tax_name: tax.name,
        tax_percentage: tax.amount,
        taxable_amount: -this._calculateTaxable(tax.id)
      })
    })

    let totalDiscount = 0
    let totalGratuity = 0
    let totalGrossSales = 0
    let totalNetSales = 0
    let totalTax = 0
    let totalRedeemAmount = 0
    let subtotal = 0
    for (var st in refundItems) {
      refundItems[st].forEach((refundItem) => {
        if (refundItem.isRefunded) {
          totalDiscount += refundItem.refundAmount * refundItem.discountPerItem
          totalGratuity += refundItem.refundAmount * refundItem.gratuityPerItem
          totalGrossSales += refundItem.refundAmount * refundItem.grossPerItem
          totalNetSales += refundItem.refundAmount * refundItem.netPerItem
          totalTax += refundItem.refundAmount * refundItem.taxPerItem
          totalRedeemAmount += refundItem.refundAmount * refundItem.redemptionPerItem
          subtotal += (refundItem.refundAmount * refundItem.pricePerItem) - (totalDiscount + totalRedeemAmount)
        }
      })
    }

    let totalCollected = totalNetSales + totalGratuity + totalTax

    let loyalty = null
    if (transactionDetail.loyalty) {
      loyalty = {
        new_earned_points: 0,
        program_id: transactionDetail.loyalty.program_id,
        member_since: transactionDetail.loyalty.member_since,
        earning_rule: transactionDetail.loyalty.earning_rule,
        member_id: transactionDetail.loyalty.member_id,
        member_uniq_id: transactionDetail.loyalty.member_uniq_id,
        member_guid: transactionDetail.loyalty.member_guid
      }

      if (transactionDetail.loyalty.type.toUpperCase() === 'REDEMPTION') {
        let {redemption} = transactionDetail.loyalty
        loyalty.redemption = {
          'redeem_points': redemption.redeem_points,
          'redeem_amount': -totalRedeemAmount,
          'reward_type': redemption.reward_type,
          'reward_id': redemption.reward_id,
          'reward': redemption.reward,
          'discount': redemption.discount,
          'discount_type': redemption.discount_type
        }
      }

      if (transactionDetail.loyalty.type.toUpperCase() === 'EARNING') {
        loyalty.new_earned_points = this._calculateLoyaltyRefundedPoint(transactionDetail, subtotal)
      }
    }

    let newPromos = []
    refundItemsPromo && refundItemsPromo.forEach((refundPromo) => {
      if (refundPromo.isChecked) {
        let refundCount = 0
        let refundAmount = 0
        let refundTotalReward = 0
        let refundGross = 0
        let canBeRefunded = false

        let newItems = refundPromo.items.map(item => {
          if (itemCallbacks.find(newItem => newItem.parent_checkout_id === item.checkout_id)) {
            refundAmount = -itemCallbacks.find(newItem => newItem.parent_checkout_id === item.checkout_id).quantity
            refundCount = refundAmount / (item.amount / refundPromo.count)
            refundTotalReward = refundAmount * (item.total_rewarded / item.amount)
            refundGross += refundTotalReward
            canBeRefunded = true

            return {
              amount: refundAmount,
              category_id: item.category_id,
              category_name: item.category_name,
              item_id: item.item_id,
              item_name: item.item_name,
              item_variant_id: item.item_variant_id,
              item_variant_name: item.item_variant_name,
              total_rewarded: -refundTotalReward,
              checkout_id: item.checkout_id,
              promo_item_status: item.promo_item_status,
              promo_requirement_id: item.promo_requirement_id,
              promo_reward_id: item.promo_reward_id
            }
          }
        })

        if (canBeRefunded) {
          let data = {
            business_id: refundPromo.business_id,
            count: refundCount,
            gross: -refundGross,
            items: newItems,
            outlet_id: refundPromo.outlet_id,
            promo_id: refundPromo.promo_id,
            promo_name: refundPromo.promo_name,
            refunded_from: refundPromo.items.find(x => x.checkout_id).payment_promo_id,
            reward_amount: refundPromo.reward_amount,
            reward_discount_type: refundPromo.reward_discount_type,
            promo_type_id: refundPromo.promo_type_id
          }
          newPromos.push(data)
        }
      }
    })

    let data = {
      amount: Math.round(transactionDetail.total_collected - transactionDetail.total_refund),
      client_created_at: moment().format(),
      custom_reason: this.state.reasonForRefund === 'Other' ? this.state.otherReasonForRefund : '',
      discounts: discounts,
      gratuities: gratuities,
      is_refund_transaction: true,
      items: itemCallbacks,
      payment_id: transactionDetail.id,
      reason: this.state.reasonForRefund !== 'Other' ? this.state.reasonForRefund : this.state.otherReasonForRefund,
      refund_amount: totalNetSales,
      taxes: taxes,
      loyalty: loyalty,
      total_collected: -totalCollected,
      total_discount: -totalDiscount,
      total_redeem_amount: -totalRedeemAmount,
      total_gratuity: -totalGratuity,
      total_gross_sales: -totalGrossSales,
      total_net_sales: -totalNetSales,
      total_tax: -totalTax,
      subtotal: -subtotal,
      promos: newPromos
    }

    const maxAmountToRefund = Math.round(transactionDetail.total_collected - transactionDetail.total_refund)
    const amountToRefund = totalNetSales
    const {search: {outlet, date: {startDate, endDate}}} = this.props
    mpReportsTransactions.reportsTransactionRefund({
      amount: amountToRefund,
      isFullRefund: Math.abs(amountToRefund - maxAmountToRefund) < 0.0001,
      outletIds: outlet,
      startDate: startDate,
      endDate: endDate
    })

    this.props.dispatch(issueRefundRequest({refund: data}))
  }

  _calculateLoyaltyRefundedPoint = (transactionDetail, currentSubTotalRefund) => {
    let parentSubTotal = transactionDetail.subtotal
    let previousFullSubTotalRefunded = this._getFullSubTotalRefunded(transactionDetail)
    let earningRule = transactionDetail.loyalty.earning_rule
    let refundedPoint = transactionDetail.payment_refunds
      .map((e) => { return e.loyalty ? e.loyalty.point_correction : 0 })
      .reduce((first, second) => first + second, 0)

    let currentAvailablePoint = transactionDetail.loyalty.new_earned_points - Math.abs(refundedPoint)

    let finalCustomerSpendingAmount = parentSubTotal - previousFullSubTotalRefunded - currentSubTotalRefund
    return parseInt(finalCustomerSpendingAmount / earningRule.amount) * earningRule.point - currentAvailablePoint
  }

  _getFullSubTotalRefunded = (transactionDetail) => {
    // when gratuity and tax is included
    // sub_total will be the same with the final amount
    // hence we dont need to do any special calculation
    if (transactionDetail.include_gratuity_tax) {
      return transactionDetail.total_refund
    } else {
      let fullSubTotalRefund = 0
      for (let i = 0; i < transactionDetail.payment_refunds.length; i++) {
        let paymentRefund = transactionDetail.payment_refunds[i]
        let totalTaxes = paymentRefund
          .payment_taxes
          .map((e) => e.total)
          .reduce((first, second) => first + second, 0)

        let totalGratuity = paymentRefund
          .payment_gratuities
          .map((e) => e.total)
          .reduce((first, second) => first + second, 0)

        let subTotalRefund = paymentRefund.refund_amount - Math.abs(totalTaxes + totalGratuity)
        fullSubTotalRefund += subTotalRefund
      }
      return fullSubTotalRefund
    }
  }

  _isSelectedAll = () => {
    let isRefundedAll = true
    let {refundItems} = this.props.data.reports.transactions.refundBreakdown
    for (var salesType in refundItems) {
      refundItems[salesType].forEach(refundItem => {
        if (refundItem.maxQuantity > 0 && !refundItem.isRefunded) {
          isRefundedAll = false
        }
      })
    }
    return isRefundedAll
  }

  _onClickSelectAll = () => {
    let {refundItems, refundItemsPromo} = this.props.data.reports.transactions.refundBreakdown
    for (var salesType in refundItems) {
      refundItems[salesType].forEach(refundItem => {
        if (refundItem.maxQuantity > 0) { // can be refunded if only max_qty > 0
          refundItem.isRefunded = true
        }
      })
    }

    this.props.dispatch(setRefundItems(refundItems))

    if (refundItemsPromo && refundItemsPromo.length > 0) {
      refundItemsPromo.forEach(refundItemPromo => {
        refundItemPromo.isChecked = true
      })
    }

    this.props.dispatch(setRefundItemsPromo(refundItemsPromo))
  }

  _onClickDeselectAll = () => {
    let {refundItems, refundItemsPromo} = this.props.data.reports.transactions.refundBreakdown
    for (var salesType in refundItems) {
      refundItems[salesType].forEach(refundItem => {
        refundItem.isRefunded = false
      })
    }
    if (refundItemsPromo && refundItemsPromo.length > 0) {
      refundItemsPromo.forEach(promo => {
        promo.isChecked = false
      })
    }
    this.props.dispatch(setRefundItems(refundItems))
    this.props.dispatch(setRefundItemsPromo(refundItemsPromo))
  }

  _onClickCheck = (salesType, idx) => {
    let {refundItems} = this.props.data.reports.transactions.refundBreakdown
    refundItems[salesType][idx].isRefunded = !refundItems[salesType][idx].isRefunded
    this.props.dispatch(setRefundItems(refundItems))
  }

  // get promo idx from promo item to be refunded
  _getPromoIdx = (refundItem) => {
    let {refundItemsPromo} = this.props.data.reports.transactions.refundBreakdown

    if (refundItemsPromo && refundItemsPromo.length > 0) {
      let promoIdx = null
      let idx = 0
      while (idx < refundItemsPromo.length) {
        let promoItem = refundItemsPromo[idx].items.find(itemPromo => itemPromo.checkout_id === refundItem.parentCheckoutId)
        if (promoItem) {
          promoIdx = idx
          break
        }
        idx++
      }
      return promoIdx
    }
  }

  _onClickCheckPromo = (refundItem) => {
    let {refundItems, refundItemsPromo} = this.props.data.reports.transactions.refundBreakdown
    let promoIdx = this._getPromoIdx(refundItem)

    refundItemsPromo.forEach((promo, idx) => {
      if (idx === promoIdx) {
        promo.isChecked = !promo.isChecked
        // refund an item of promo should refund all items of selected package promo
        if (promo.items && promo.items.length > 0) {
          promo.items.forEach(itemPromo => {
            for (let salesType in refundItems) {
              refundItems[salesType].forEach(item => {
                if (item.parentCheckoutId === itemPromo.checkout_id) {
                  item.isRefunded = promo.isChecked
                }
              })
            }
          })
        }
      }
    })

    this.props.dispatch(setRefundItems(refundItems))
  }

  /**
   * @param {int} idx index of refundItems in array of refundBreakdown
   * @private
   */
  _onClickDecreaseQty = (salesType, idx) => {
    let {refundItems} = this.props.data.reports.transactions.refundBreakdown
    if (refundItems[salesType][idx].refundAmount > 1) {
      refundItems[salesType][idx].refundAmount -= 1
      this.props.dispatch(setRefundItems(refundItems))
    }
  }

  /**
   * @param {int} idx index of refundItems in array of refundBreakdown
   * @private
   */
  _onClickIncreaseQty = (salesType, idx) => {
    let {refundItems} = this.props.data.reports.transactions.refundBreakdown
    if (refundItems[salesType][idx].refundAmount < refundItems[salesType][idx].maxQuantity) {
      refundItems[salesType][idx].refundAmount += 1
      this.props.dispatch(setRefundItems(refundItems))
    }
  }

  // calculate minimum amount requirement of promo
  _countPromoRequirement = (requirementId) => {
    let {refundItemsPromo} = this.props.data.reports.transactions.refundBreakdown
    let countRequirement = 0
    let amountRequirement = 0
    let minReq = 0

    if (refundItemsPromo && refundItemsPromo.length > 0) {
      refundItemsPromo.forEach(promo => {
        promo.items.forEach(itemPromo => {
          if (itemPromo.promo_requirement_id === requirementId) {
            amountRequirement += itemPromo.amount
          }
        })

        if (promo.items.find(item => item.promo_requirement_id === requirementId)) {
          countRequirement += promo.count
        }
      })

      minReq = amountRequirement / countRequirement
    }

    return minReq
  }

  // calculate minimum amount reward
  _countPromoReward = (rewardId) => {
    let {refundItemsPromo} = this.props.data.reports.transactions.refundBreakdown
    let countReward = 0
    let amountReward = 0
    let minReward = 0

    if (refundItemsPromo && refundItemsPromo.length > 0) {
      refundItemsPromo.forEach(promo => {
        promo.items.forEach(itemPromo => {
          if (itemPromo.promo_reward_id === rewardId) {
            amountReward += itemPromo.amount
          }
        })

        if (promo.items.find(item => item.promo_reward_id === rewardId)) {
          countReward += promo.count
        }
      })

      minReward = amountReward / countReward
    }
    return minReward
  }

  _onClickIncreaseQtyPromo = (refundItem) => {
    let {refundItems, refundItemsPromo} = this.props.data.reports.transactions.refundBreakdown
    let promoIdx = this._getPromoIdx(refundItem)

    refundItemsPromo.map((promo, idx) => {
      // get all promo requirement id in a bundle promo
      let valueArr = promo.items.map(x => x.promo_requirement_id)
      // check if a bundle promo has duplicate requirement id
      let isDuplicate = valueArr.some((val, i) => valueArr.indexOf(val) !== i)

      if (!isDuplicate) {
        if (idx === promoIdx) {
          if (promo.items && promo.items.length > 0) {
            promo.items.forEach(item => {
              for (let salesType in refundItems) {
                refundItems[salesType].forEach(refundItem => {
                  if (refundItem.parentCheckoutId === item.checkout_id) {
                    let counter = 0
                    if (item.promo_item_status !== 'REWARD') {
                      counter = this._countPromoRequirement(item.promo_requirement_id)
                    } else {
                      counter = this._countPromoReward(item.promo_reward_id)
                    }

                    if (refundItem.refundAmount < refundItem.maxQuantity) {
                      refundItem.refundAmount += parseInt(counter)
                      this.props.dispatch(setRefundItems(refundItems))
                    }
                  }
                })
              }
            })
          }
        }
      } else {
        this._setQtyWithDuplicateReq(promo, idx, refundItem, promoIdx, 'plus')
      }
    })
  }

  _onClickDecreaseQtyPromo = (refundItem) => {
    let {refundItems, refundItemsPromo} = this.props.data.reports.transactions.refundBreakdown
    let promoIdx = this._getPromoIdx(refundItem)

    refundItemsPromo.forEach((promo, idx) => {
      // get all promo requirement id in a bundle promo
      let valueArr = promo.items.map(x => x.promo_requirement_id)
      // check if items in a bundle promo has duplicate requirement id
      let isDuplicate = valueArr.some((val, i) => valueArr.indexOf(val) !== i)

      if (!isDuplicate) {
        if (idx === promoIdx) {
          if (promo.items && promo.items.length > 0) {
            promo.items.forEach(item => {
              for (let salesType in refundItems) {
                refundItems[salesType].forEach(refundItem => {
                  if (refundItem.parentCheckoutId === item.checkout_id) {
                    let counter = 0
                    if (item.promo_item_status !== 'REWARD') {
                      counter = this._countPromoRequirement(item.promo_requirement_id)
                    } else {
                      counter = this._countPromoReward(item.promo_reward_id)
                    }

                    let minAmountPromo = parseInt(counter)

                    if (refundItem.refundAmount > minAmountPromo) {
                      refundItem.refundAmount -= minAmountPromo
                      this.props.dispatch(setRefundItems(refundItems))
                    }
                  }
                })
              }
            })
          }
        }
      } else {
        this._setQtyWithDuplicateReq(promo, idx, refundItem, promoIdx, 'minus')
      }
    })
  }

  // to handle https://mokapos.atlassian.net/browse/FD-2795
  _setQtyWithDuplicateReq = (promo, idx, refundItem, promoIdx, sign) => {
    let {refundItems} = this.props.data.reports.transactions.refundBreakdown
    let temp = []
    let arrRefundItems = []
    let totalQty = 0

    // if items in one bundle
    if (idx === promoIdx) {
      if (promo.items && promo.items.length > 0) {
        // push items promo with same requirement in temp
        promo.items.forEach(item => {
          temp.push(item)
        })

        // total quantity of items with same requirement
        temp.forEach(item => {
          totalQty += item.amount
        })

        for (let salesType in refundItems) {
          refundItems[salesType].forEach(item => {
            if (temp.length > 0) {
              // find items in refundItems (refund_availibility)
              if (temp.find(a => a.checkout_id === item.parentCheckoutId)) {
                arrRefundItems.push(item)
              }
            }
          })
        }
      }
    }

    // do decrease from last index. increase from first index

    let counter = parseInt(totalQty / promo.count)
    let totalRefundedQty = 0
    arrRefundItems.forEach(item => {
      totalRefundedQty += item.maxQuantity
    })
    // if clicked button is "-" button
    if (sign === 'minus') {
      let index = 0
      arrRefundItems.reverse()

      while (index < arrRefundItems.length) {
        if (index !== arrRefundItems.length - 1) {
          if (arrRefundItems[index].refundAmount > 0 && counter < totalRefundedQty) {
            arrRefundItems[index].refundAmount -= counter
            break
          }
        } else {
          if (arrRefundItems[index].refundAmount > counter) {
            arrRefundItems[index].refundAmount -= counter
            break
          }
        }
        index++
      }
      // set refundItems in form
      this.props.dispatch(setRefundItems(refundItems))
    } else { // if clicked button is "+" button
      let index = 0
      while (index < arrRefundItems.length) {
        if (arrRefundItems[index].refundAmount < arrRefundItems[index].maxQuantity) {
          arrRefundItems[index].refundAmount += counter
          break
        }
        index++
      }
      // set refundItems in form
      this.props.dispatch(setRefundItems(refundItems))
    }
  }

  /**
   *
   * @param idx
   * @private
   */
  _isChecked = (salesType, idx) => {
    let {refundItems} = this.props.data.reports.transactions.refundBreakdown
    return refundItems[salesType][idx].isRefunded
  }

  _canBeRefunded = (salesType, idx) => {
    let {refundItems} = this.props.data.reports.transactions.refundBreakdown
    return (
      (
        (!refundItems[salesType][idx].refundAmount && this._calculateItemPrice(salesType, idx) === 0) ||
        (this._calculateItemPrice(salesType, idx) > 0 && refundItems[salesType][idx].refundAmount > 0)
      ) &&
        refundItems[salesType][idx].maxQuantity > 0
    )
  }

  _isRefunded = (salesType, idx) => {
    let {refundItems} = this.props.data.reports.transactions.refundBreakdown
    return refundItems[salesType][idx].isRefunded
  }

  _onChangeInputAmountRefunded = (salesType, idx, value) => {
    let {refundItems} = this.props.data.reports.transactions.refundBreakdown
    let maxQuantity = refundItems[salesType][idx].maxQuantity
    if (parseInt(value)) {
      if (value > maxQuantity) {
        refundItems[salesType][idx].refundAmount = parseInt(maxQuantity)
      } else {
        refundItems[salesType][idx].refundAmount = parseInt(value)
      }
    } else {
      refundItems[salesType][idx].refundAmount = refundItems[salesType][idx].maxQuantity
    }
    this.props.dispatch(setRefundItems(refundItems))
  }

  _onAskSetQtyModal = (idx, salesTypeName, refundAmount) => {
    this.props.dispatch(askSetQuantity(idx, salesTypeName, refundAmount))
  };

  _onCancelSetQtyModal = () => {
    this.props.dispatch(cancelSetQuantity())
  }

  _onConfirmSetQtyModal = (salesType, idx, value) => {
    let {refundItems} = this.props.data.reports.transactions.refundBreakdown
    let maxQuantity = refundItems[salesType][idx].maxQuantity
    if (value) {
      if (value > maxQuantity) {
        refundItems[salesType][idx].refundAmount = maxQuantity
      } else {
        refundItems[salesType][idx].refundAmount = value
      }
    } else {
      refundItems[salesType][idx].refundAmount = 0
    }
    this.props.dispatch(confirmSetQuantity(refundItems))
  };

  /**********************************************************************
   * Calculation
   **********************************************************************/

  _calculateAmountToRefund = () => {
    let {refundItems} = this.props.data.reports.transactions.refundBreakdown
    let {transactionDetail} = this.props.data.reports.transactions
    let totalGratuities = 0
    let totalTaxes = 0
    let totalItems = 0
    let totalDiscountCash = 0
    let totalPromoPrice = 0
    let totalDiscountCashPromoItem = 0

    for (let salesType in refundItems) {
      refundItems[salesType].forEach((refundItem, idx) => {
        if (refundItem.isRefunded) {
          if (!this._isPromoItem(refundItem.parentCheckoutId)) {
            let itemPrice = this._calculateItemPrice(salesType, idx)
            if (!refundItem.maxQuantity) {
              totalDiscountCash += itemPrice - refundItem.netPerItem
            } else {
              totalDiscountCash += itemPrice - (refundItem.refundAmount * refundItem.netPerItem)
            }
            totalItems += itemPrice
          } else {
            let promoPrice = this._calculatePromoItemPrice(refundItem)
            if (!refundItem.maxQuantity) {
              totalDiscountCashPromoItem += promoPrice - refundItem.netPerItem
            } else {
              totalDiscountCashPromoItem += promoPrice - (refundItem.refundAmount * refundItem.netPerItem)
            }
            totalPromoPrice += promoPrice
          }
        }
      })
    }

    transactionDetail.payment_gratuities.forEach((gratuity) => {
      totalGratuities += this._calculateGratuity(gratuity.gratuity_id)
    })

    transactionDetail.payment_taxes.forEach((tax) => {
      totalTaxes += this._calculateTax(tax.id)
    })

    return (totalItems - totalDiscountCash) + (totalPromoPrice - totalDiscountCashPromoItem) + totalGratuities + totalTaxes
  }

  _calculateItemPriceIncluded = (salesType, itemId) => {
    let {refundItems} = this.props.data.reports.transactions.refundBreakdown
    let refundItem = refundItems[salesType][itemId]
    let itemPrice = 0
    // if all refunded
    if (!refundItem.maxQuantity) {
      itemPrice = (refundItem.netPerItem + this._calculateDiscountCash(refundItem.discounts) + refundItem.redemptionPerItem + refundItem.taxPerItem + refundItem.gratuityPerItem)
    } else {
      itemPrice = refundItem.refundAmount * (refundItem.netPerItem + this._calculateDiscountCash(refundItem.discounts) + refundItem.redemptionPerItem + refundItem.taxPerItem + refundItem.gratuityPerItem)
    }
    if (itemPrice < 0) itemPrice = 0
    return itemPrice
  }

  _calculateItemPrice = (salesType, itemId) => {
    let {refundItems} = this.props.data.reports.transactions.refundBreakdown
    let refundItem = refundItems[salesType][itemId]
    let itemPrice = 0
    // if all refunded
    if (!refundItem.maxQuantity) {
      itemPrice = (refundItem.netPerItem + this._calculateDiscountCash(refundItem.discounts) + refundItem.redemptionPerItem)
    } else {
      itemPrice = refundItem.refundAmount * (refundItem.netPerItem + this._calculateDiscountCash(refundItem.discounts) + refundItem.redemptionPerItem)
    }
    if (itemPrice < 0) itemPrice = 0
    return itemPrice
  }

  _calculateDiscountCash (discounts) {
    let discountCash = 0
    discounts.forEach(discount => {
      if (discount.discount_type === 'cash') {
        discountCash += discount.discount_per_item
      }
    })
    return discountCash
  }

  _isPromoItem = (checkoutId) => {
    let { refundItemsPromo } = this.props.data.reports.transactions.refundBreakdown
    let isPromo = false

    if (refundItemsPromo) {
      let idx = 0
      while (idx < refundItemsPromo.length) {
        if (refundItemsPromo[idx].items && refundItemsPromo[idx].items.find(item => item.checkout_id === checkoutId)) {
          isPromo = true
          break
        }
        idx++
      }
    }
    return isPromo
  }

  _isFreeItem = (checkoutId) => {
    let { refundItemsPromo } = this.props.data.reports.transactions.refundBreakdown
    let isFree = false
    let idx = 0
    if (refundItemsPromo) {
      while (idx < refundItemsPromo.length) {
        if (refundItemsPromo[idx].items && refundItemsPromo[idx].items.length > 0) {
          let itemPromo = refundItemsPromo[idx].items.find(item => item.checkout_id === checkoutId)
          if (itemPromo && itemPromo.promo_item_status === 'REWARD') {
            isFree = true
            break
          }
        }
        idx++
      }
    }
    return isFree
  }

  // get promo name for each promo item to be refunded
  _getPromoName = (refundItem) => {
    let {refundItemsPromo} = this.props.data.reports.transactions.refundBreakdown

    if (refundItemsPromo && refundItemsPromo.length > 0) {
      let promoName = ''
      let idx = 0
      while (idx < refundItemsPromo.length) {
        let promoItem = refundItemsPromo[idx].items.find(itemPromo => itemPromo.checkout_id === refundItem.parentCheckoutId)
        if (promoItem) {
          promoName = refundItemsPromo[idx].promo_name
          break
        }
        idx++
      }
      return promoName
    }
  }

  _calculatePromoItemPrice = (refundItem) => {
    let { refundItemsPromo } = this.props.data.reports.transactions.refundBreakdown
    let promoPrice = 0
    if (refundItemsPromo) {
      refundItemsPromo.forEach(promo => {
        if (promo.items && promo.items.find(itemPromo => itemPromo.checkout_id === refundItem.parentCheckoutId)) {
          let disc = 0
          let discountRp = 0

          if (!refundItem.maxQuantity) {  // if all items have been refunded
            promoPrice = refundItem.netPerItem
          } else {
            promoPrice = refundItem.refundAmount * (refundItem.pricePerItem - refundItem.discountPerItem)
          }

          // need this code since discount from promo is calculated in discount_per_item inside block refund_availibility,
          // but not included in discount_per_item inside discounts[].
          if (refundItem.discounts && refundItem.discounts.length > 0) {
            refundItem.discounts.forEach(discount => {
              // discount Rp from promo is treated differently from discount Rp non promo
              if (discount.discount_type === 'cash') {
                // total discount Rp in block discounts
                discountRp += discount.discount_per_item
                // total discount from promo
                disc = refundItem.discountPerItem - discountRp
                if (!refundItem.maxQuantity) {  // if all items have been refunded
                  promoPrice = refundItem.netPerItem + discountRp
                } else {
                  promoPrice = refundItem.refundAmount * (refundItem.pricePerItem - disc)
                }
              }
            })
          }
        }
      })
    }
    return promoPrice
  }

  // calculate price after percentage discount
  _calculatePriceAfterDiscountPercentage = (salesType, itemIdx) => {
    const { transactionDetail, refundBreakdown } = this.props.data.reports.transactions
    const { refundItems } = refundBreakdown
    // salesType === "null" means no sales type. it should be "" for no sales type. remove this code when it is correct
    const keySalesType = salesType === 'null' ? '' : salesType
    let itemPrice = 0
    let item = refundItems[salesType][itemIdx]
    let discountPercentage = 0.0

    // calculate discount percentage
    if (item.discounts && item.discounts.length > 0) {
      item.discounts.forEach(discount => {
        if (discount.discount_type === 'percentage') {
          discountPercentage += parseFloat(discount.discount_percentage)
        }
      })
    }

    // non promo item price after percentage discount
    if (!this._isPromoItem(item.parentCheckoutId)) {
      let price = transactionDetail.checkouts[keySalesType].find(checkout => checkout.id === item.parentCheckoutId).price
      itemPrice = (1 - (discountPercentage / 100.0)) * price
    } else {  // promo item price after reward and discount
      let promoItemPrice = 0
      let priceAfterDiscount = 0
      let rewardAmount = 0

      promoItemPrice = transactionDetail.checkouts[keySalesType].find(checkout => checkout.id === item.parentCheckoutId).price
      priceAfterDiscount = (1 - (discountPercentage / 100.0)) * promoItemPrice

      if (transactionDetail.promos) {
        transactionDetail.promos.forEach(promo => {
          let promoFound = promo.items && promo.items.find(promoItem => promoItem.checkout_id === item.parentCheckoutId)
          if (promoFound) {
            if (promo.reward_discount_type === 'PERCENTAGE') {
              rewardAmount = (promo.reward_amount / 100.0) * promoItemPrice
            } else {  // free item or cash reward
              rewardAmount = promoFound.total_rewarded
            }
          }
        })
      }

      // handle promo with reward discount 100%
      // will return 0 if reward > item price
      if (promoItemPrice > rewardAmount) {
        itemPrice = priceAfterDiscount - rewardAmount
      }
    }

    return itemPrice
  }

  _calculateDiscount = (discountId, discountAmount) => {
    let { transactionDetail, refundBreakdown } = this.props.data.reports.transactions
    let { refundItems } = refundBreakdown
    let total = 0   // total discount Rp to be displayed on issue refund popup in Discount section
    let totalDisc = 0   // total discount Rp for checked non promo items
    let totalDiscPromo = 0  // total discount Rp of checked promo items
    let totalPrice = 0  // sum of displayed items price on popup issue refund
    let price = 0   // total price of non promo items to be refunded
    let totalPromoPrice = 0   // total price of promo items to be refunded

    for (let salesType in refundItems) {
      refundItems[salesType].forEach((refundItem, index) => {
        if (refundItem.isRefunded) {
          if (this._isPromoItem(refundItem.parentCheckoutId)) {
            totalPromoPrice += this._calculatePromoItemPrice(refundItem)
          } else {
            if (!transactionDetail.include_gratuity_tax) {
              price += this._calculateItemPrice(salesType, index)
            } else {
              price += this._calculateItemPriceIncluded(salesType, index)
            }
          }
        }

        // this calculation needed for discount Rp breakdown
        totalPrice += this._calculatePriceAfterDiscountPercentage(salesType, index)
        totalDisc = price / totalPrice * discountAmount
        totalDiscPromo = totalPromoPrice / totalPrice * discountAmount
        total = totalDisc + totalDiscPromo
      })
    }
    return total
  }

  _calculateRedeemAmount = () => {
    let {refundItems} = this.props.data.reports.transactions.refundBreakdown
    let totalAmount = 0
    for (var salesType in refundItems) {
      totalAmount += refundItems[salesType].filter(item => item.isRefunded).reduce((total, item) => {
        return total + (item.redemptionPerItem * item.refundAmount)
      }, 0)
    }
    return totalAmount
  }

  _calculateGratuity = (gratuityId) => {
    let {transactionDetail} = this.props.data.reports.transactions
    let {refundItems} = this.props.data.reports.transactions.refundBreakdown
    let total = 0
    for (var salesType in refundItems) {
      refundItems[salesType].forEach((refundItem) => {
        if (refundItem.isRefunded) {
          if (refundItem.salesTypeId && refundItem.salesTypeId !== 0) {
            refundItem.gratuities.forEach((gratuity) => {
              if (gratuity.gratuity_id === gratuityId) {
                total += (gratuity.amount / 100) * refundItem.refundAmount * (refundItem.netPerItem)
              }
            })
          } else {
            transactionDetail.payment_gratuities.forEach((gratuity) => {
              if (gratuity.gratuity_id === gratuityId) {
                total += (gratuity.amount / 100) * refundItem.refundAmount * (refundItem.netPerItem)
              }
            })
          }
        }
      })
    }
    return total
  }

  _calculateTax = (taxId) => {
    let {transactionDetail} = this.props.data.reports.transactions
    let {refundItems} = this.props.data.reports.transactions.refundBreakdown
    let total = 0
    transactionDetail.payment_taxes.forEach((tax) => {
      if (tax.id === taxId) {
        for (var salesType in refundItems) {
          refundItems[salesType].forEach((refundItem) => {
            if (refundItem.isRefunded) {
              total += (tax.amount / 100.0) * refundItem.refundAmount * (refundItem.netPerItem + refundItem.gratuityPerItem)
            }
          })
        }
      }
    })
    return total
  }

  _calculateTaxable = (taxId) => {
    let {transactionDetail} = this.props.data.reports.transactions
    let {refundItems} = this.props.data.reports.transactions.refundBreakdown
    let total = 0
    transactionDetail.payment_taxes.forEach((tax) => {
      if (tax.id === taxId) {
        for (var salesType in refundItems) {
          refundItems[salesType].forEach((refundItem) => {
            if (refundItem.isRefunded) {
              total += refundItem.refundAmount * (refundItem.netPerItem + refundItem.gratuityPerItem)
            }
          })
        }
      }
    })
    return total
  }

  /**********************************************************************
   * End of Calculation
   **********************************************************************/
}

TransactionRefundModal.propTypes = {
}

const selector = formValueSelector('search')

function mapStateToProps (state) {
  return {
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date')
    },
    data: {
      reports: {
        transactions: state.reports.transactions
      }
    }
  }
}

export default connect(mapStateToProps)(TransactionRefundModal)



// WEBPACK FOOTER //
// ./app/components/receipt/refunds/TransactionRefundModal/TransactionRefundModal.js